import { render, staticRenderFns } from "./VerkaufshilfenPage.vue?vue&type=template&id=5f86a845&"
import script from "./VerkaufshilfenPage.vue?vue&type=script&lang=js&"
export * from "./VerkaufshilfenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports